import styled from "styled-components";
import { ReactComponent as Light } from "../assets/icon-component/light.svg";
import { ReactComponent as LightABC } from "../../../abc/src/data/icon-component/theme_switcher.svg";
import { isMobile, isTablet } from "react-device-detect";
import { is } from "date-fns/locale";

export const StyledLight = styled(Light)`
  cursor: pointer;
  width: 40px;
  fill: var(--icon-bulb);
  margin: 0 12px;
  @media (max-width: 767px) {
    margin: 0;
  }
`;

export const StyledLightABC = styled(LightABC)`
  cursor: pointer;
  width: 40px;
  fill: var(--icon-bulb);
  margin: 0 12px;
  .st0 {
    fill: ${({ theme }) => (theme.current === "dark" ? "#14162c" : "#E3E6EA")};
  }
  .st1 {
    fill: #1a4294;
  }
  @media (max-width: 767px) {
    margin: 0;
  }
`;

export const IconBulbHidden = styled.div`
  width: 40px;
  margin: 0 12px;
`;

export const SessionTime = styled.div`
  position: ${isMobile && "absolute"};
  top: ${({ isSv }) => isMobile && (isSv ? "9px" : "5px")};
  width: ${isMobile && "100%"};
  left: ${isMobile && "0"};
  text-align: ${isMobile && "center"};
  padding-top: ${isMobile && "5px"};
  display: ${({ isSv }) => isMobile && isSv && "ruby"};
  div,
  p {
    color: #ffff;
    font-size: 0.6rem;
    max-width: ${({ isSv }) => (isSv || isMobile ? "100%" : "100px")};
    line-height: 1.3;
    padding: ${isMobile && "0 1px"};
  }
  div {
    margin: ${!isMobile && "0 10px"};
  }
`;

export const LanguageSelect = styled.select`
  background-color: transparent;
  outline: none;
  border: none;
  color: #fff;
  font-size: inherit;
  -moz-appearance: ${({ theme }) =>
    theme.skin === "yet" ||
    theme.skin === "fun" ||
    theme.skin === "cac" ||
    theme.skin === "hyc"
      ? ""
      : "none"};
  -webkit-appearance: ${({ theme }) =>
    theme.skin === "yet" ||
    theme.skin === "fun" ||
    theme.skin === "cac" ||
    theme.skin === "hyc"
      ? ""
      : "none"};
  background-color: var(--racProfileMenuCol);
  color: ${({ theme }) =>
    theme.skin === "cac" || theme.skin === "hyc" ? "#fff" : "var(--headerbtn)"};
  border-radius: ${({ theme }) =>
    theme.skin === "fun" || theme.skin === "cac"
      ? "20px"
      : theme.skin === "hyc"
        ? "10px"
        : theme.skin === "yet"
          ? "0.5rem"
          : "5px"};
  padding: ${({ theme, userInfoProp }) =>
    theme.skin === "yet" || theme.skin === "fun" || theme.skin === "hyc"
      ? theme.skin === "fun" && userInfoProp
        ? "14px"
        : userInfoProp
          ? "10px"
          : "7px"
      : "5px"};
  text-transform: uppercase;
  font-weight: ${({ theme }) =>
    theme.skin === "yet" || theme.skin === "fun" ? "500" : "700"};

  margin: "0 5px";
  border: ${({ theme }) =>
    theme.skin === "cac" || theme.skin === "qbc" || theme.skin === "bec"
      ? "1px solid #979797"
      : ""};
  cursor: pointer;
  text-align: center;
  transition: background-color 300ms;

  :hover {
    background-color: ${({ theme }) =>
      theme.skin === "fun"
        ? "#195ab8"
        : theme.skin === "cac"
          ? "#322d2e"
          : theme.skin === "hyc"
            ? "#211b48"
            : "#21729c"};
  }

  option {
    background-color: ${({ theme }) =>
      theme.skin === "fun"
        ? "#195ab8"
        : theme.skin === "cac"
          ? "#1E1D19"
          : theme.skin === "hyc"
            ? "#000"
            : "#11628d"};
    color: ${({ theme }) =>
      theme.skin === "fun" ? "var(--headerbtn)" : "#fff"};
    text-align: left;
  }

  /* &::-ms-expand {
    display: none;
  } */
`;
